/**
 *    Copyright 2018 the original author or authors
 * 
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 * 
 *        http://www.apache.org/licenses/LICENSE-2.0
 * 
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExtendzOpenlayerRoutingModule } from './extendz-openlayer-routing.module';
import { ExtedzOpenlayerComponent } from './extendz-openlayer.component';
import { ExtendzOpenlayerService } from './extendz-openlayer.service';

import {MatToolbarModule, MatSelectModule, MatIconModule, MatButtonModule, MatProgressBarModule, MatInputModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    ExtendzOpenlayerRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    MatInputModule,
    MatSelectModule
  ],
  declarations: [ExtedzOpenlayerComponent],
  providers:[ExtendzOpenlayerService],
  exports:[ExtedzOpenlayerComponent]
})
export class ExtendzOpenlayerModule { }
